import { TabItem } from './contracts';

/** "South Central" -> "south-central", so a label is usable verbatim in a URL. */
const slugify = (value: string): string => value.trim().toLowerCase().replace(/\s+/g, '-');

/**
 * Which tab a `?tab=` value names, or -1 when it names none.
 *
 * Tab ids are uuids generated by the page builder, so a hand-authored link realistically
 * addresses a tab by its LABEL — `/clubs?tab=east`. Ids are still matched first, and matched
 * exactly, so a link written against an id keeps working after the label is renamed.
 *
 * Returning -1 rather than 0 for "no match" keeps the fallback decision with the caller: an
 * unknown value must leave the component on its default tab, not silently select something.
 */
export function resolveTabIndex(tabs: readonly TabItem[] | undefined, requested: string | null | undefined): number {
  if (!tabs || tabs.length === 0 || typeof requested !== 'string') {
    return -1;
  }

  const trimmed = requested.trim();
  if (trimmed.length === 0) {
    return -1;
  }

  const byId = tabs.findIndex((tab) => tab.id === trimmed);
  if (byId !== -1) {
    return byId;
  }

  const wanted = slugify(trimmed);
  return tabs.findIndex((tab) => slugify(tab.label) === wanted);
}
